import React from 'react';
import {Form} from 'antd';

const FormItem = Form.Item;
class AisinoFormItem extends React.Component {

    render() {
        return(
            <FormItem {...this.props} colon={false}/>
        );
    }
}
export default AisinoFormItem;